import React from 'react';
import PropTypes from 'prop-types';

const GridContainer = ({ columns, className, gap, alignItems, style, children, ...rest }) => (
  <div
    className={className}
    style={{
      ...style,
      display: 'grid',
      gridTemplateColumns: columns,
      gridGap: gap,
      alignItems,
    }}
    {...rest}
  >
    {children}
  </div>
);

GridContainer.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.string.isRequired,
  gap: PropTypes.string.isRequired,
  alignItems: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
};

GridContainer.defaultProps = {
  alignItems: 'center',
  style: {},
  className: '',
};

export default GridContainer;
